webpackJsonp([3],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Простой прелоадер
 * @module
 */

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Дофелтный конфиг для всех экземпляров прелоадера
 * @type {Object}
 * @prop {string} mainClass - основной CSS класс, который добавляется к контейнеру прелодара
 * @prop {string} subClass - Дополнительный CSS класс - который будет добавлен, если имеет логически позитивное значение
 * @prop {string} showClass - CSS класс, который добавляется к контейнеру прелодара, при его показе
 * @prop {string} hideClass - CSS класс, который добавляется к контейнеру прелодара, перед его закрытием
 * @prop {number} removeDelay - время задержки, после которой будут удалены разметка прелоадре и CSS классы у контейнера
 * @prop {string} markup - Разметка прелодера
 * @private
 */

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultConfig = {
	mainClass: 'preloader',
	subClass: '',
	showClass: 'preloader--show',
	hideClass: 'preloader--hide',
	removeDelay: 200,
	markup: '<div class="preloader__block"></div>'
};

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Создание прелодаров
 * @param {jQuery} $container - контейнер для прелоадера
 * @param {Object} [userConfig={}] - Пользвательский конфиг для создваемого экземпляра
 * @prop {jQuery} [$container] - контейнер для прелоадера
 * @prop {jQuery} [$markup] - блок разметки прелоадера
 * @prop {Object|number} timer - id таймера
 * @example
 * let preloader = new Preloader($myElement);
 * preloader.show();
 * window.setTimeout(() => preloader.hide(), 1000);
 */

var Preloader = function () {
	function Preloader($container) {
		var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, Preloader);

		if ($container.data('preloader') instanceof Preloader) {
			return $container.data('preloader');
		}
		this.$container = $container;
		this.config = $.extend(true, {}, Preloader.config, userConfig);
		this.timer = null;
		this.$container.data('preloader', this);
	}

	/**
  * Показ прелодера
  * @param {string} [place="append"] - append / prepend / before / after
  * @sourceCode
  */


	_createClass(Preloader, [{
		key: 'show',
		value: function show() {
			var _this = this;

			var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'append';
			var _config = this.config,
			    mainClass = _config.mainClass,
			    subClass = _config.subClass,
			    showClass = _config.showClass;

			this.$container.addClass(mainClass);
			if (subClass) {
				this.$container.addClass(subClass);
			}
			this.$markup = $(this.config.markup);
			this.$container[place](this.$markup);

			window.clearTimeout(this.timer);
			this.timer = window.setTimeout(function () {
				return _this.$container.addClass(showClass);
			}, 10);
		}

		/**
   * Скрытие прелодера
   * @param {boolean} [removeMarkup=true] - удалить разметку прелодера после скрытия
   * @sourceCode
   */

	}, {
		key: 'hide',
		value: function hide() {
			var _this2 = this;

			var removeMarkup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
			var _config2 = this.config,
			    mainClass = _config2.mainClass,
			    subClass = _config2.subClass,
			    showClass = _config2.showClass,
			    hideClass = _config2.hideClass;

			this.$container.addClass(hideClass);
			window.clearTimeout(this.timer);
			this.timer = window.setTimeout(function () {
				if (removeMarkup) {
					_this2.$markup.remove();
				}
				_this2.$container.removeClass([mainClass, showClass, hideClass].join(' '));
				if (subClass) {
					_this2.$container.removeClass(subClass);
				}
			}, this.config.removeDelay + 50);
		}

		/**
   * Получение глобального конфига для всех прелодаров
   * @returns {Object}
   * @sourceCode
   */

	}], [{
		key: 'config',
		get: function get() {
			return defaultConfig;
		}

		/**
   * Установка глобального конфига
   * @param {Object} value
   * @sourceCode
   * @example
   * Preloader.config = {mainClass: 'my-preloader'}
   */
		,
		set: function set(value) {
			$.extend(true, defaultConfig, value);
		}
	}]);

	return Preloader;
}();

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = Preloader;

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Внутрення, горизотальная прокрутка элементов со стилизацией
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(4);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Внутренний namespace
 * @const {string}
 * @private
 * @sourceCode
 */
var ns = 'horizontal-scroll';

/**
 * Список собранных элементов, к кототорым применен скролл
 * @type {Array}
 * @private
 * @sourceCode
 */
var $list = [];

/**
 * Обработчик собития `scroll.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {number} event.data.gap
 * @param {jQuery} event.data.$wrapper
 * @param {jQuery} event.data.$element
 * @private
 * @sourceCode
 */
function onScroll(event) {
  var $holder = $(this);
  var _event$data = event.data,
      gap = _event$data.gap,
      $wrapper = _event$data.$wrapper,
      $element = _event$data.$element;


  var holderWidth = $holder.innerWidth();
  var holderScroll = $holder.scrollLeft();
  var holderScrollOffset = holderScroll + holderWidth + gap;
  var tableWidth = $element[0].scrollWidth;

  var doClassLeft = 'removeClass';
  var doClassRight = 'removeClass';

  if (holderScroll > gap) {
    doClassLeft = 'addClass';
  }

  if (tableWidth > holderScrollOffset) {
    doClassRight = 'addClass';
  }

  $wrapper[doClassLeft](ns + '--left');
  $wrapper[doClassRight](ns + '--right');

  if ($holder.data(ns + '-synchronized') !== true) {
    $element.data(ns + '-$holders').forEach(function ($syncHolder) {
      $syncHolder.data(ns + '-synchronized', true);
      $syncHolder.scrollLeft(holderScroll);
    });
  }
  $holder.data(ns + '-synchronized', false);
}

/**
 * Обработчик собития `destroy.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @private
 * @sourceCode
 */
function onDestroy(event) {
  var _$this$off$unwrap$unw;

  var $this = $(this);
  var $holder = event.data.$holder;

  var index = $list.index($holder);
  if (~index) {
    $list.splice(index, 1);
    if ($list.length === 0) {
      $(window).off('resize.' + ns, onResize);
    }
  }
  $this.off('destroy.' + ns, onDestroy).unwrap().unwrap().removeClass(ns + '__element').removeInitedKey(ns).data((_$this$off$unwrap$unw = {}, _defineProperty(_$this$off$unwrap$unw, ns + '-$holder', null), _defineProperty(_$this$off$unwrap$unw, ns + '-$holders', null), _$this$off$unwrap$unw));
}

/**
 * Обработчик собития `mousedown.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onDown(event) {
  var _event$data2 = event.data,
      $holder = _event$data2.$holder,
      $wrapper = _event$data2.$wrapper;

  $wrapper.addClass(ns + '--mousedown');
  $holder.on('mousemove.' + ns, { $holder: $holder, $wrapper: $wrapper, downX: event.pageX }, onMove);
}

/**
 * Обработчик собития `mouseup.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onUp(event) {
  var _event$data3 = event.data,
      $holder = _event$data3.$holder,
      $wrapper = _event$data3.$wrapper;

  $wrapper.removeClass(ns + '--mousedown');
  $holder.off('mousemove.' + ns, onMove);
}

/**
 * Обработчик собития `mousemove.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onMove(event) {
  var gutter = 12;
  var _event$data4 = event.data,
      downX = _event$data4.downX,
      $holder = _event$data4.$holder,
      $wrapper = _event$data4.$wrapper;
  var x = event.pageX,
      y = event.pageY;


  var offset = $wrapper.offset();
  var left = offset.left + gutter;
  var top = offset.top + gutter;
  var right = left - gutter * 2 + $wrapper.innerWidth();
  var bottom = top - gutter * 2 + $wrapper.innerHeight();

  if (x < left || x > right || y < top || y > bottom) {
    $holder.trigger('mouseup.' + ns);
    return false;
  }
  var scroll = $holder.scrollLeft() - (x - downX) / 2;
  $holder.scrollLeft(scroll);
}

/**
 * Обработчик собития `destroy.${ns}` для `window`
 * @private
 * @sourceCode
 */
function onResize() {
  if ($list.length) {
    $list.trigger('scroll');
  }
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Оборачивание элементов и добавление прослушки на горизотальную прокрутку.
 * При инициализации каждому элементу добавляеться запись `data('horizontal-scroll', true)`
 * Для того чтобы отфильтровывать уже инициализированные элементы при возможных последующих обращениях
 *
 * Каждому элементу добавляеться CSS класс, а также оборачивается нужной разметкой
 * для стилизации и возможность устастановки прослушек.
 *
 * Пример начальной разметки
 *
 * ```markup
 * <div class="wysiwyg">
 *     <table>
 *         <!-- content -->
 *     </table>
 * </div>
 * ```
 *
 * Пример результата
 *
 * ```markup
 * <div class="wysiwyg">
 *     <div class="horizontal-scroll"> <!-- Стилизация псевдоэлементами слева и справа в зависимости от прокрутки -->
 *         <div class="horizontal-scroll__holder"> <!-- Создает прокрутку и не нем же весят события скрола -->
 *             <table class="horizontal-scroll__element">
 *                 <!-- content -->
 *             </table>
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Инит таблиц</caption>
 * horizontalScroll('.wysiwyg table');
 *
 * @example <caption>Инит таблиц в текущем контейнере</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Инит таблиц в текущем контейнере с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer, 20);
 *
 * @example <caption>Инит таблиц с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', null, 20);
 *
 * @param {string|jQuery} selector - поиск элементов по селектору или jQuery element
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @param {number} [gap=4] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @sourceCode
 */
function horizontalScroll(selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;

  var $elements = selector && selector.jquery ? selector : $(selector, $context);

  $elements.each(function (i, el) {
    var $element = $(el);

    if ($element.hasInitedKey(ns, false)) {
      return true;
    }

    $element.addClass(ns + '__element').wrap('<div class="' + ns + '"><div class="' + ns + '__holder"></div></div>');
    horizontalScroll.init($element, gap);
  });
}

/**
 * Инициализация прослушки
 * Метод можно использовать отдельно, если у вас уже есть готовая структура разметки
 *
 * Необходимая структура
 *
 * ```markup
 * <div class="horizontal-scroll">
 *     <div class="horizontal-scroll__holder">
 *         <div class="horizontal-scroll__element">
 *             <!-- content -->
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Необходимая структура</caption>
 * let $element = $('.horizontal-scroll__element);
 * horizontalScroll.init($element);
 * // horizontalScroll.init($element, 20); // => с зазором в 20 пикселей
 *
 * @param {jQuery} $element - поиск элементов по селектору
 * @param {number} [gap=3] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @method horizontalScroll::init
 * @inner
 */
horizontalScroll.init = function ($element) {
  var gap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  if ($element.hasInitedKey(ns)) {
    return true;
  }

  var $holder = $element.parent();
  var $wrapper = $holder.parent();

  $holder.on('scroll.' + ns, { gap: gap, $element: $element, $wrapper: $wrapper }, onScroll);
  $holder.on('mousedown.' + ns, { $holder: $holder, $wrapper: $wrapper }, onDown);
  $holder.on('mouseup.' + ns, { $holder: $holder, $wrapper: $wrapper }, onUp);
  $holder.on('dragstart.' + ns, function () {
    return false;
  });
  $element.on('destroy.' + ns, { $holder: $holder }, onDestroy);
  $element.data(ns + '-$holder', $holder);
  $element.data(ns + '-$holders', []);

  if ($list.length) {
    $list = $list.add($holder);
  } else {
    $list = $holder;
    $(window).on('resize.' + ns, onResize);
  }

  $holder.trigger('scroll.' + ns);
};

/**
 * Синхронизация скролов
 * __Важно!__ метод нужно вызывать после инициализации скролов для каждлго из элементов
 *
 * @example
 * let $elements = $('.elements');
 * horizontalScroll($elements);
 * horizontalScroll.sync($elements);
 *
 * @param $elements
 * @method horizontalScroll::sync
 * @inner
 * @sourceCode
 */
horizontalScroll.sync = function ($elements) {
  $elements.each(function (i, el) {
    var $el = $(el);
    var $holders = [];

    $elements.not($el).each(function (i, el) {
      $holders.push($(el).data(ns + '-$holder'));
    });

    $el.data(ns + '-$holders', $holders);
  });
};

/**
 * Удаление внутреннего скролла
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table');
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Удаление внутреннего скрола с нужного элемента</caption>
 * horizontalScroll.destroy($myElement);
 *
 * @param {string|jQuery} selector - Селектор или jQuery элемент
 * @param {string} selector.jquery - Если передан элемент - строка, содержащая номер версии `jQuery` ({@link http://api.jquery.com/jquery-2/})
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @method horizontalScroll::destroy
 * @inner
 */
horizontalScroll.destroy = function (selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (selector && selector.jquery) {
    selector.trigger('destroy.' + ns);
    return;
  }

  $(selector, $context).each(function (i, el) {
    var $element = $(el);
    $element.trigger('destroy.' + ns);
  });
};

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = horizontalScroll;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Оборачивание элементов для пропорцинальной адаптации
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(4);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function wrapMedia(selector) {
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $el = $(el);
		if ($el.hasInitedKey('wrap-media', false)) {
			return true;
		}

		var width = parseInt($el.attr('width') || $el[0].offsetWidth);
		var height = parseInt($el.attr('height') || $el[0].offsetHeight);
		var ratio = parseFloat((height / width * 100).toFixed(2));

		$el.unwrap('p').wrap('\n\t\t<div class="ratio-wrapper" style="max-width:' + width + 'px;margin-left:auto;margin-right:auto;">\n\t\t\t<div class="ratio" style="padding-top:' + ratio + '%;"></div>\n\t\t</div>\n\t\t');

		console.log($el);
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = wrapMedia;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит валидации форм
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(4);

var _Preloader = __webpack_require__(1);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function validate() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-form';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $forms = selector && selector.jquery ? selector : $(selector, $context);
	$forms.each(function (i, el) {
		var $form = $(el);
		if ($form.hasInitedKey('validator', false)) {
			return true;
		}

		var preloader = new _Preloader2.default($form);
		preloader.show();

		__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 52)).then(function (config) {
			var configDefault = config.default;

			var _require = __webpack_require__(24),
			    setHandlers = _require.default;

			var configUser = $form.data('validation-config') || {};
			var configCurrent = $.extend(true, {}, configDefault, configUser);

			$form.validate(configCurrent);
			setHandlers($form, $form.data('validator'));
			preloader.hide();
		});
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = validate;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var electric = true;
var usa = true;
var unbroken = true;
var $calculator = $('.calculator-form');
var $calculatorResults = $('.calculator__results-wrap');
var $autoCostOutput = $('#price-output');
var $autoTotalOutput = $('#total-output');
var $ndsOutput = $('#nds-output');
var $dutyOutput = $('#duty-output');
var $exciseOutput = $('#excise-output');
var $customsTotalOutput = $('#customs-total-output');
var $deliveryOutput = $('#delivery-output');
var $brokerOutput = $('#broker-output');
var $certificateOutput = $('#certificate-output');
var $deliveryTotalOutput = $('#delivery-total-output');
var $autoCostInput = $('#auto-price-input');
var $engineInput = $('#auto-engine-input');
var $submitBtn = $('.calculator-submit-btn');
var $resetBtn = $('.calculator-reset-btn');
var $electricWrap = $('.calculator__results--electric');
var $gasWrap = $('.calculator__results--gas');
var $fuelInput = $('#fuel-select');
var $countryInput = $('#country-select');
var $stateInput = $('#state-select');
var ndsTotal = void 0;
var dutyTotal = void 0;
var exciseTotal = void 0;
var customsTotal = void 0;
var autoCost = void 0;
var autoTotalCost = void 0;
var engineValue = void 0;
var brokenCustomTotal = void 0;
var deliveryCost = $electricWrap.data('delivery');
var brokerCost = $electricWrap.data('broker');
var certificateCost = $electricWrap.data('certificate');
var ndsValue = $gasWrap.data('nds');
var dutyValue = $gasWrap.data('duty');
var exciseValue = $gasWrap.data('excise');
var referenceCost = $gasWrap.data('reference');
var deliveryEuroCost = $gasWrap.data('delivery-euro');
var deliveryUsaCost = $gasWrap.data('delivery-usa');
var deliveryTotal = void 0;

// Thousand separator

function setThousands(numberText, newSeparator, separator) {
	newSeparator = newSeparator || '.';
	separator = separator || '.';
	numberText = '' + numberText;
	numberText = numberText.split(separator);

	var numberPenny = numberText[1] || '';
	var numberValue = numberText[0];

	var thousandsValue = [];
	var counter = 0;

	for (var i = numberValue.length - 1; i >= 0; i--) {
		var num = numberValue[i];
		thousandsValue.push(num);

		if (++counter === 3 && i) {
			thousandsValue.push(' ');
			counter = 0;
		}
	}

	thousandsValue = thousandsValue.reverse().join('');
	if (numberPenny.length) {
		return [thousandsValue, numberPenny].join(newSeparator);
	}
	return thousandsValue;
}

function calculateResults(value) {
	// get values
	$autoCostInput.on('change', function () {
		autoCost = $(this).val();

		console.log(autoCost);
	});

	$engineInput.on('change', function () {
		engineValue = $(this).val();

		console.log(engineValue);
	});

	// calculate values
	autoCost = parseInt(autoCost);
	engineValue = parseInt(engineValue);
	deliveryTotal = deliveryCost + brokerCost + certificateCost;

	dutyTotal = Math.floor(autoCost * dutyValue / 100);
	exciseTotal = Math.floor(engineValue * exciseValue);
	ndsTotal = Math.floor((autoCost + dutyTotal + exciseTotal + referenceCost + (usa ? deliveryUsaCost : deliveryEuroCost)) * ndsValue);
	customsTotal = Math.floor(dutyTotal + exciseTotal + ndsTotal);
	brokenCustomTotal = customsTotal - customsTotal * 20 / 100;

	autoTotalCost = autoCost + (electric ? deliveryTotal : customsTotal);
}

function setResults() {
	calculateResults();

	// append values on the page
	$autoCostOutput.text(setThousands(autoCost) + ' $');
	$autoTotalOutput.text(setThousands(autoTotalCost) + ' $');

	if (electric) {
		$deliveryOutput.text(setThousands(deliveryCost) + ' $');
		$brokerOutput.text(setThousands(brokerCost) + ' $');
		$certificateOutput.text(setThousands(certificateCost) + ' $');
		$deliveryTotalOutput.text(setThousands(deliveryTotal) + ' $');
	} else {
		$ndsOutput.text(setThousands(ndsTotal) + ' $');
		$dutyOutput.text(setThousands(dutyTotal) + ' $');
		$exciseOutput.text(setThousands(exciseTotal) + ' $');
		$customsTotalOutput.text(setThousands(unbroken ? customsTotal : brokenCustomTotal) + ' $');
	}

	if (!electric) {
		$electricWrap.addClass('_hide');
		$gasWrap.removeClass('_hide');
	} else {
		$gasWrap.addClass('_hide');
		$electricWrap.removeClass('_hide');
	}

	$calculatorResults.slideDown('slow');
	$submitBtn.addClass('hidden');
}

// ----------------------------------------
// Public
// ----------------------------------------

function onlineCalculator() {
	if (!$calculator.length) {
		return false;
	}

	$engineInput.attr(electric ? 'readonly' : 'required', true);

	$autoCostInput.on('change', function () {
		autoCost = $(this).val();
	});

	$engineInput.on('change', function () {
		engineValue = $(this).val();
	});

	$fuelInput.on('select2:select', function () {
		var value = $(this).val();

		electric = value === 'electric';

		$engineInput.removeAttr(electric ? 'required' : 'readonly').attr(electric ? 'readonly' : 'required', true);
	});

	$countryInput.on('select2:select', function () {
		var value = $(this).val();

		usa = value === 'usa';
	});

	$stateInput.on('select2:select', function () {
		var value = $(this).val();

		unbroken = value === 'unbroken';
	});

	$resetBtn.on('click', function () {
		$calculatorResults.slideUp('slow');
		$calculator.trigger('reset');
		$submitBtn.removeClass('hidden');
	});

	$('.calculator__to-catalog').on('click', function () {
		$calculator.trigger('reset');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.onlineCalculator = onlineCalculator;
exports.setResults = setResults;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @fileOverview Основной файл инициализации модулей
 */

// ----------------------------------------
// Imports
// ----------------------------------------

__webpack_require__(15);

__webpack_require__(20);

__webpack_require__(21);

var _horizontalScroll = __webpack_require__(6);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _wrapMedia = __webpack_require__(7);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

var _validate = __webpack_require__(8);

var _validate2 = _interopRequireDefault(_validate);

var _mfpAjax = __webpack_require__(25);

var _mfpAjax2 = _interopRequireDefault(_mfpAjax);

var _mfpInline = __webpack_require__(26);

var _mfpInline2 = _interopRequireDefault(_mfpInline);

var _mfpIframe = __webpack_require__(27);

var _mfpIframe2 = _interopRequireDefault(_mfpIframe);

var _mfpGallery = __webpack_require__(28);

var _mfpGallery2 = _interopRequireDefault(_mfpGallery);

var _menu = __webpack_require__(29);

var _sliders = __webpack_require__(31);

var _profitCalculator = __webpack_require__(33);

var _onlineCalculator = __webpack_require__(13);

var _scrollmagic = __webpack_require__(35);

var _header = __webpack_require__(38);

var _select = __webpack_require__(39);

var _subMenu = __webpack_require__(40);

var _rangeSlider = __webpack_require__(41);

var _textWrap = __webpack_require__(44);

var _map = __webpack_require__(45);

var _wstabs = __webpack_require__(46);

var _wstabs2 = _interopRequireDefault(_wstabs);

var _selectWord = __webpack_require__(48);

var _video = __webpack_require__(49);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Public
// ----------------------------------------

window.jQuery(document).ready(function ($) {
	(0, _horizontalScroll2.default)('.wysiwyg table');
	(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video');
	(0, _validate2.default)('.js-form');
	(0, _mfpAjax2.default)();
	(0, _mfpInline2.default)();
	(0, _mfpIframe2.default)();
	(0, _mfpGallery2.default)();
	(0, _menu.mainMenu)();
	(0, _sliders.mainSlider)();
	(0, _profitCalculator.profitCalculator)();
	(0, _scrollmagic.headerScrollMagic)();
	(0, _scrollmagic.calculationScrollMagic)();
	(0, _scrollmagic.infoScrollMagic)();
	(0, _scrollmagic.firstSlideAnimation)();
	(0, _sliders.offerSlider)();
	(0, _header.headerLang)();
	(0, _header.headerSearch)();
	(0, _select.initSelect)();
	(0, _subMenu.subMenuToggle)('.sidebar-menu-toggle', '.sidebar__menu-item--child', '.sidebar__sub-menu');
	(0, _rangeSlider.initRangeSlider)();
	(0, _menu.filtersMenu)();
	(0, _sliders.similarSlider)();
	(0, _sliders.photoSlider)();
	(0, _scrollmagic.productScrollMagic)();
	(0, _textWrap.textWrap)();
	(0, _onlineCalculator.onlineCalculator)();
	(0, _map.initMap)();
	_wstabs2.default.init();
	_wstabs2.default.setActive(); // если нужно принудительно активировать табы
	(0, _menu.scrollTo)();
	(0, _selectWord.selectWord)();

	(0, _video2.default)('.js-mainSlider');
});

if (true) {
	__webpack_require__(50);
}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит плгина lozad.js
 * @module
 * @see {@link https://github.com/ApoorvSaxena/lozad.js}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

__webpack_require__(22);

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Коллбек вставки источника
 * @param {jQuery} $el
 * @private
 * @sourceCode
 */
function onLoad($el) {
	var $parent = $el.parent('.lozad-parent');
	var delay = $el.data('lozad-delay') || 50;
	setTimeout(function () {
		if ($parent.length) {
			$parent.addClass('lozad-parent--is-ready');
		}
		$el.addClass('lozad--is-ready');
	}, delay);
}

/**
 * Добавлеям `lazyLoad` к глобальныму объекту `window`
 * @private
 * @sourceCode
 */
function createLazyLoad() {
	var lozad = __webpack_require__(23);
	window.lazyLoad = lozad('.lozad', {
		load: function load(el) {
			var $el = $(el);
			var nodeName = $el.nodeName();
			var img = document.createElement('img');

			if (nodeName === 'picture') {
				var $img = $(img);
				$img.on('load', function () {
					return onLoad($el);
				});
				$el.append($img);
			} else {
				var src = $el.data('lozad');
				img.onload = function () {
					if ($el.nodeName() === 'img') {
						$el.attr('src', src);
					} else {
						$el.css('background-image', 'url(' + src + ')');
					}
					onLoad($el);
				};
				img.src = src;
			}
		}
	});

	window.lazyLoad.observe();
}

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	if (!$('.lozad').length) {
		return false;
	}

	// если уже `lazyLoad` добавлен вызываем
	if (window.lazyLoad) {
		return window.lazyLoad.observe();
	}

	// иначе добавляем
	if (window.Modernizr.intersectionobserver) {
		createLazyLoad();
	} else {
		// грузим асинхронно полифилл если не поддерживается Intersection Observer
		__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 51)).then(createLazyLoad);
	}
})(window.jQuery);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Пользовательские обработчики формы
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {jQuery} $form
 * @param {Object} Validator {@link https://jqueryvalidation.org/?s=validator}
 * @param {Function} Validator.resetForm {@link https://jqueryvalidation.org/Validator.resetForm/}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function setHandlers($form, Validator) {
  // сброс формы
  $form.on('reset', function () {
    return Validator.resetForm();
  });

  // дальше ваш код
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = setHandlers;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип ajax
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#ajax-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _validate = __webpack_require__(8);

var _validate2 = _interopRequireDefault(_validate);

var _horizontalScroll = __webpack_require__(6);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _wrapMedia = __webpack_require__(7);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

var _Preloader = __webpack_require__(1);

var _Preloader2 = _interopRequireDefault(_Preloader);

__webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {string} [selector='.js-mfp-ajax']- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	var config = $.extend(true, {
		mainClass: 'mfp-animate-zoom-in',
		type: 'ajax',
		delegate: selector,
		removalDelay: 300,
		closeMarkup: '<button class=\'mfp-close\' id=\'custom-close-btn\'></button>',
		callbacks: {
			elementParse: function elementParse(item) {
				var _item$el$data = item.el.data(),
				    url = _item$el$data.url,
				    _item$el$data$type = _item$el$data.type,
				    type = _item$el$data$type === undefined ? 'POST' : _item$el$data$type,
				    _item$el$data$param = _item$el$data.param,
				    data = _item$el$data$param === undefined ? {} : _item$el$data$param;

				this.st.ajax.settings = { url: url, type: type, data: data };
			},
			ajaxContentAdded: function ajaxContentAdded() {
				var $container = this.contentContainer || [];
				$('.select2').select2({
					minimumResultsForSearch: Infinity,
					dropdownParent: $('.select2-wrap'),
					placeholder: $('.select2').data('placeholder'),
					width: 'resolve'
				});
				if ($container) {
					(0, _horizontalScroll2.default)('.wysiwyg table', $container);
					(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video', $container);
					(0, _validate2.default)('.js-form', $container);
				}
			}
		}
	}, userConfig);

	$context.magnificPopup(config);
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {string} [selector='.js-mfp-ajax']- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpAjax() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-ajax';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('body');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	function load(event) {
		event.preventDefault();
		$context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3)).then(function () {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.trigger(event.type);
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpAjax;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип inline
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#inline-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Preloader = __webpack_require__(1);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {string} [selector=".js-mfp-inline"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $element = $(el);
		var config = $.extend(true, {
			type: 'inline',
			closeBtnInside: false,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in',
			closeMarkup: '<button class="mfp-close" id="custom-close-btn"></button>'
		}, userConfig);

		$element.magnificPopup(config);
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {string} [selector=".js-mfp-inline"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpInline() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-inline';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('body');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	function load(event) {
		event.preventDefault();
		$context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3)).then(function () {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.magnificPopup('open');
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpInline;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип iframe
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#iframe-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Preloader = __webpack_require__(1);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {string} [selector=".js-mfp-iframe"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $element = $(el);
		var config = $.extend(true, {
			type: 'iframe',
			closeBtnInside: true,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in'
		}, userConfig);

		$element.magnificPopup(config);
	});
}

var myConfig = {
	closeMarkup: '<button class="mfp-close" id="custom-close-btn--video"></button>',

	iframe: {
		markup: '<div class="mfp-iframe-scaler">' + '<button class="mfp-close" id="custom-close-btn--video"></button>' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '<div class="mfp-title"></div>' + '</div>',
		patterns: {
			youtube: {
				index: 'youtube.com/',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?autoplay=1'
			}
		},
		srcAction: 'iframe_src'
	}
};

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {string} [selector=".js-mfp-iframe"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpIframe() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-iframe';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('body');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	function load(event) {
		event.preventDefault();
		$context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3)).then(function () {
			init(selector, $context, myConfig);
			preloader.hide();
			$element.magnificPopup('open');
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpIframe;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип image, с галереей
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#image-type}
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#gallery}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Preloader = __webpack_require__(1);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {string} [selector="[data-mfp-src]"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('.js-mfp-gallery')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	$context.each(function (i, el) {
		var $element = $(el);
		var config = $.extend(true, {
			type: 'image',
			delegate: selector,
			closeMarkup: '<button class="mfp-close" id="custom-close-btn"></button>',
			gallery: {
				enabled: true,
				preload: [0, 2],
				navigateByImgClick: true,
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%" id="custom-arrow-%dir%"></button>'
			},
			closeBtnInside: true,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in',
			callbacks: {
				elementParse: function elementParse(item) {

					if ($(item.el[0]).data('video')) {
						item.type = 'iframe';
					} else {
						item.type = 'image';
					}

					console.log(item.type);
				}
			}
		}, userConfig);

		$element.magnificPopup(config);
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {string} [selector="[data-mfp-src]"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('.js-mfp-gallery')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpGallery() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-mfp-src]';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('.js-mfp-gallery');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	function load(event) {
		event.preventDefault();
		$context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3)).then(function () {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.trigger(event.type);
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpGallery;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.scrollTo = exports.filtersMenu = exports.mainMenu = undefined;

__webpack_require__(30);

// ----------------------------------------
// Private
// ----------------------------------------

var filters = $('#filters');
var $openBnt = $('#menu-open');
var $closeBtn = $('#menu-close');
var $openFiltersBnt = $('.mobile-filters-btn');
var $closeFiltersBtn = $('.mobile-btn');

var $toProfitBtn = $('.to-profit-calculator.index');

// ----------------------------------------
// Public
// ----------------------------------------

function mainMenu() {
	var $menu = $('#menu').mmenu({
		'slidingSubmenus': false,
		'extensions': ['pagedim-white', 'position-right', 'position-front', 'border-none'],
		'navbar': {
			add: false
		}
	});

	var API = $menu.data('mmenu');

	$openBnt.on('click', function () {
		API.open();
	});

	$closeBtn.click(function () {
		API.close();
	});
}

function filtersMenu() {
	var $filters = filters.mmenu({
		'extensions': ['pagedim-black', 'fx-menu-slide', 'border-none', 'theme-white'],
		'navbar': {
			add: false
		}
	});

	var API = $filters.data('mmenu');

	$openFiltersBnt.on('click', function () {
		API.open();
	});

	$closeFiltersBtn.click(function () {
		API.close();
	});
}

function scrollTo() {
	var API = $('#menu').data('mmenu');

	$toProfitBtn.on('click', function () {
		API.close();

		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - 300
			}, 1000);
			return false;
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.mainMenu = mainMenu;
exports.filtersMenu = filtersMenu;
exports.scrollTo = scrollTo;

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.photoSlider = exports.similarSlider = exports.offerSlider = exports.mainSlider = undefined;

__webpack_require__(32);

// ----------------------------------------
// Private
// ----------------------------------------

var $mainSlider = $('.main-slider');
var $offerSlider = $('.offers-slider');
var $similarSlider = $('.similar-slider');
var $photoSlider = $('.photo-slider');
var $photoNavSlider = $('.photo-nav-slider');
var $offerControls = $('.offers-slider__control');
var $similarControls = $('.similar-slider__control');
var $video = $('video');

// ----------------------------------------
// Public
// ----------------------------------------

function mainSlider() {

	var mailSlider = $mainSlider.slick($.extend({}, true, {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		autoplay: true,
		prevArrow: '<button type=\'button\' class=\'slick-arrow slick-prev\'></button>',
		nextArrow: '<button type=\'button\' class=\'slick-arrow slick-next\'></button>'
	}, $mainSlider.data('param')));

	var autoplayStatus = false;

	if ($mainSlider.length && $mainSlider.data('param').autoplay) {
		autoplayStatus = true;
	}

	$mainSlider.on('afterChange', function (event, slick, currentSlide) {
		videoOllPause();
		// let $video = $(slick.$slider[0]).find('video');
		// console.log(slick);
		// console.log($(slick.$slider[0]));

		var $slide = $('.js-mainSlider .slick-active'),
		    $video = $slide.find('video');
		if ($video.length) {
			$mainSlider.slick('slickSetOption', 'autoplay', false, true);
			$video[0].play();
		} else {

			if (autoplayStatus) {
				$mainSlider.slick('slickSetOption', 'autoplay', true, true);
			}
		}

		// if($(slick.$slider[0]).find('video').length){
		// 	$(slick.$slider).find('video').play();
		// } else {
		// 	$mainSlider.slickSetOption("autoplay",false,false);
		// }
	});

	var $slide = $('.js-mainSlider .slick-active'),
	    $video = $slide.find('video');
	if ($video.length) {
		$video[0].play();
	}

	var $videoList = $mainSlider.find('video');

	$videoList.each(function (i, el) {
		el.addEventListener('ended', function () {
			videoOllPause();
			// $mainSlider.slickSetOption("autoplay",true,false);
			if (autoplayStatus) {
				$mainSlider.slick('slickSetOption', 'autoplay', true, true);
				$mainSlider.slick('slickNext');
			} else {
				var _$slide = $('.js-mainSlider .slick-active'),
				    _$video = _$slide.find('video');
				if (_$video.length) {
					_$video[0].currentTime = 0;
					_$video[0].play();
				}
			}
		}, false);

		$(el).on("startVideo", function () {
			console.log('start');
			el.paly();
		});
	});

	function videoOllPause() {
		$videoList.each(function (i, el) {
			el.pause();
			el.currentTime = 0;
		});
	}
}

function offerSlider() {
	$offerSlider.slick($.extend({}, true, {
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		infinite: true,
		dots: true,
		appendDots: $offerControls,
		touchThreshold: 12,
		appendArrows: $('.offers-block'),
		centerPadding: '0',
		autoplay: true,
		prevArrow: '<button type=\'button\' class=\'slick-arrow slick-prev\'><span class="slick-arrow-icon slick-prev-icon"></span></button>',
		nextArrow: '<button type=\'button\' class=\'slick-arrow slick-next\'><span class="slick-arrow-icon slick-next-icon"></span></button>',
		responsive: [{
			breakpoint: 1025,
			settings: {
				slidesToShow: 1
			}
		}]
	}, $offerSlider.data('param')));
}

function similarSlider() {
	$similarSlider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		dots: true,
		autoplay: true,
		appendDots: $similarControls,
		prevArrow: '<button type=\'button\' class=\'slick-arrow slick-prev\'></button>',
		nextArrow: '<button type=\'button\' class=\'slick-arrow slick-next\'></button>',
		responsive: [{
			breakpoint: 1025,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 641,
			settings: {
				slidesToShow: 1
			}
		}]
	});
}

function photoSlider() {
	$photoSlider.slick({
		slidesToShow: 1,
		infinite: true,
		fade: true,
		dots: false,
		autoplay: false,
		accessibility: false,
		asNavFor: $photoNavSlider,
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>'
	});

	$photoNavSlider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: $photoSlider,
		focusOnSelect: true,
		vertical: true,
		infinite: true,
		arrows: true,
		autoplay: false,
		prevArrow: '<button type="button" class="slick-arrow trumb__prev slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow trumb__next slick-next"></button>',
		responsive: [{
			breakpoint: 1440,
			settings: {
				slidesToShow: 4
			}
		}, {
			breakpoint: 1280,
			settings: {
				vertical: false
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 4,
				vertical: false
			}
		}, {
			breakpoint: 640,
			settings: {
				slidesToShow: 3,
				vertical: false
			}
		}]
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.mainSlider = mainSlider;
exports.offerSlider = offerSlider;
exports.similarSlider = similarSlider;
exports.photoSlider = photoSlider;

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.calculator = exports.profitCalculator = undefined;

__webpack_require__(34);

// ----------------------------------------
// Private
// ----------------------------------------
var $rangeSlider = $('.range-slider');
var $calculator = $('.calculator');
var $rangeEl = void 0;
var month = 30;
var year = 365;
var gasPrice = $calculator.data('gas');
var kbtPrice = $calculator.data('electro');
var stoPrice = $calculator.data('sto');
var $totalLitresOutput = $('.total-litres');
var $gasPriceOutput = $('.gas-price');
var $gasTotalOutput = $('.gas-total');
var $kbtPriceOutput = $('.kbt-price');
var $electroPriceOutput = $('.electro-price');
var $electroTotalOutput = $('.electro-total');
var $stoPriceOutput = $('.sto-price');
var $stoTotalOutput = $('.sto-total');
var $gasCostOutput = $('.gas-cost');
var $electroCostOutput = $('.electro-cost');
var $yearTotalOutput = $('.year-total');
var $monthTotalOutput = $('.month-total');
var $totalProfitOutput = $('.economy-main');
var monthTotal = void 0;
var yearTotal = void 0;
var totalLitres = void 0;
var gasTotal = void 0;
var stoTotal = void 0;
var gasCost = void 0;
var electroPrice = void 0;
var electroTotal = void 0;
var electroCost = void 0;
var totalProfit = void 0;

// Thousand separator

function setThousands(numberText, newSeparator, separator) {
	newSeparator = newSeparator || '.';
	separator = separator || '.';
	numberText = '' + numberText;
	numberText = numberText.split(separator);

	var numberPenny = numberText[1] || '';
	var numberValue = numberText[0];

	var thousandsValue = [];
	var counter = 0;

	for (var i = numberValue.length - 1; i >= 0; i--) {
		var num = numberValue[i];
		thousandsValue.push(num);

		if (++counter === 3 && i) {
			thousandsValue.push(' ');
			counter = 0;
		}
	}

	thousandsValue = thousandsValue.reverse().join('');
	if (numberPenny.length) {
		return [thousandsValue, numberPenny].join(newSeparator);
	}
	return thousandsValue;
}

function cost(value) {
	// calculate the values

	monthTotal = value * month;
	yearTotal = value * year;
	totalLitres = Math.floor(yearTotal / 10);
	gasTotal = totalLitres * gasPrice;
	stoTotal = stoPrice * 2;
	gasCost = gasTotal + stoTotal;
	electroPrice = 8 * 3 * kbtPrice;
	electroTotal = electroPrice / 150;
	electroCost = Math.floor(yearTotal * electroTotal);
	totalProfit = gasCost - electroCost;

	// append values on the page

	$yearTotalOutput.text(setThousands(yearTotal));
	$monthTotalOutput.text(setThousands(monthTotal));
	$totalLitresOutput.text(setThousands(totalLitres));
	$gasTotalOutput.text(setThousands(gasTotal));
	$stoTotalOutput.text(setThousands(stoTotal));
	$gasCostOutput.text(setThousands(gasCost));
	$electroPriceOutput.text(electroPrice.toFixed(2));
	$electroTotalOutput.text(electroTotal.toFixed(2));
	$electroCostOutput.text(setThousands(electroCost));
	$totalProfitOutput.text(setThousands(totalProfit));
}

// ----------------------------------------
// Public
// ----------------------------------------

function profitCalculator() {
	if (!$calculator.length) {
		return false;
	}

	$gasPriceOutput.text(gasPrice);
	$stoPriceOutput.text(setThousands(stoPrice));
	$kbtPriceOutput.text(kbtPrice);

	var value = $rangeSlider.val();

	cost(value);

	$rangeSlider.rangeslider({
		polyfill: false,

		onInit: function onInit() {
			$rangeEl = this.$range;

			var $handle = $rangeEl.find('.rangeslider__handle');
			var handleValue = '<div class=\'rangeslider__handle-value\'>' + (this.value + ' км') + '</div>';

			$handle.append(handleValue);
		},

		onSlide: function onSlide(position, value) {
			var $handle = this.$range.find('.rangeslider__handle-value');
			$handle.text(this.value + ' км');

			cost(value);
		}

	});
}

function calculator() {}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.profitCalculator = profitCalculator;
exports.calculator = calculator;

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.productScrollMagic = exports.infoScrollMagic = exports.calculationScrollMagic = exports.firstSlideAnimation = exports.headerScrollMagic = undefined;

__webpack_require__(36);

var _scrollmagic = __webpack_require__(5);

var _scrollmagic2 = _interopRequireDefault(_scrollmagic);

var _TweenMax = __webpack_require__(10);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

var _TimelineMax = __webpack_require__(11);

var _TimelineMax2 = _interopRequireDefault(_TimelineMax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(37);

// ----------------------------------------
// Private
// ----------------------------------------

// eslint-disable-line no-unused-vars
var headerMenuWrap = '.header-menu__wrap';
var headerMenu = $('.header-menu--move');
var logoMove = $('.index-header__logo--move');
var socialMove = $('.index-header__social-wrap--move');
var $infoItem = $('.index-info__wrap');
var $productInfo = $('.item__info-wrap');
var calculatorWrap = '.calculator__wrap';
var calculatorMain = '.calculator__profit';
var calculatorLeft = '.calculator__gas';
var calculatorRight = '.calculator__electro';
var mainText = '.main-slider__text-wrap.animated';
var mainCircle = '.main-slider__circle.animated';
var $counter = $('.counter');
var count = $counter.data('count');

// ----------------------------------------
// Public
// ----------------------------------------

function firstSlideAnimation() {
	if (!mainText.length) {
		return false;
	}

	if ($(window).width() < 1024) {
		return false;
	}

	//	create timeline for main screen
	var tlMain = new _TimelineMax2.default({ paused: false });

	tlMain.staggerTo(mainCircle, 1, { scale: 1, autoAlpha: 1, ease: Power1.easeIn }) // eslint-disable-line no-undef
	.staggerTo(mainText, 1, { x: 0, autoAlpha: 1, ease: Power1.easeOut }); // eslint-disable-line no-undef
}

function headerScrollMagic() {
	var left = $(window).width() < 1800 ? 190 : 265;

	if (!$(headerMenuWrap).hasClass('move')) {
		return false;
	}

	var controller = new _scrollmagic2.default.Controller();
	var tlHeader = new _TimelineMax2.default({ paused: true });

	// create timeline for header menu
	tlHeader.to(headerMenu, 0.3, { x: left, ease: Power1.easeOut }) // eslint-disable-line no-undef
	.to(logoMove, 0.3, { x: 0, autoAlpha: 1, ease: Power1.easeOut }) // eslint-disable-line no-undef
	.from(socialMove, 0.3, { y: -300, autoAlpha: 0, ease: Power1.easeOut }, 0.5); // eslint-disable-line no-undef

	// create pin scene for header
	var headerScene = new _scrollmagic2.default.Scene({
		triggerElement: headerMenuWrap,
		triggerHook: 0
	}).setClassToggle(headerMenuWrap, 'fixed').setPin(headerMenuWrap).addTo(controller);

	// create scene for header menu
	new _scrollmagic2.default.Scene({
		triggerElement: headerMenuWrap,
		triggerHook: 0.5
	}).setClassToggle('.header__sub-menu-wrap', 'bottom')
	//	.addIndicators({name: 'menu'})
	.addTo(controller);

	headerScene.on('start', function (event) {
		tlHeader.play();
	});

	headerScene.on('leave', function (event) {
		tlHeader.reverse();
	});
}

function calculationScrollMagic() {
	if (!$(calculatorWrap).length) {
		return false;
	}

	var controller = new _scrollmagic2.default.Controller();
	var tlCalculation = new _TimelineMax2.default();

	//	create timeline for calculator block
	tlCalculation.from(calculatorMain, 1, { y: 300, autoAlpha: 0, ease: Power1.easeNone }) // eslint-disable-line no-undef
	.from(calculatorLeft, 1, { x: -300, autoAlpha: 0, ease: Power1.easeOut }, 2) // eslint-disable-line no-undef
	.from(calculatorRight, 1, { x: 300, autoAlpha: 0, ease: Power1.easeOut }, 2); // eslint-disable-line no-undef

	//	create scene for calculator
	new _scrollmagic2.default.Scene({
		triggerElement: calculatorWrap,
		triggerHook: 0.8,
		reverse: false
	}).setTween(tlCalculation)
	//	.addIndicators({name: 'calc'})
	.addTo(controller);
}

function infoScrollMagic() {
	if (!$infoItem.length) {
		return false;
	}

	var controller = new _scrollmagic2.default.Controller();

	// create scene for info block
	$infoItem.each(function () {
		var $this = $(this);

		var infoScene = new _scrollmagic2.default.Scene({
			triggerElement: this,
			triggerHook: 0.5,
			reverse: false
		}).setClassToggle(this, 'fade-in')
		//	.addIndicators({name: 'info'})
		.addTo(controller);

		infoScene.on('start', function (event) {
			if (!$this.hasClass('count')) {
				return false;
			}

			var cont = { val: 0 };

			TweenLite // eslint-disable-line no-undef
			.to(cont, 4, {
				val: count,
				roundProps: 'val',
				onUpdate: function onUpdate() {
					$counter.text(cont.val);
				},
				delay: 1,
				ease: Power0.easeOut // eslint-disable-line no-undef
			});
		});
	});
}

function productScrollMagic() {
	if (!$productInfo.length) {
		return false;
	}

	if ($(window).width() < 1024) {
		return false;
	}

	// const controller = new ScrollMagic.Controller();
	//
	// new ScrollMagic.Scene({
	// 	triggerElement: '.item__info-wrap',
	// 	triggerHook: 0.2,
	// 	duration: '100%'
	// })
	// 	.setPin('.item__info-wrap')
	// 	// .addIndicators({name: 'info'})
	// 	.addTo(controller);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.headerScrollMagic = headerScrollMagic;
exports.firstSlideAnimation = firstSlideAnimation;
exports.calculationScrollMagic = calculationScrollMagic;
exports.infoScrollMagic = infoScrollMagic;
exports.productScrollMagic = productScrollMagic;

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var $searchWrap = $('.header__search-wrap');
var $searchBox = $('.header__search-hidden');
var $searchButton = $('.header__search-btn');
var $dropdown = $('.header__top-dropdown');
var $dropdownBtn = $('.header__top-dropdown-btn');
var $dropdownIcon = $('.header__lang-icon');
var $dropdownWrap = $('.header__top-dropdown-wrap');

// ----------------------------------------
// Public
// ----------------------------------------

function headerSearch() {
	$searchButton.on('click', function () {
		var $searchWrap = $(this).closest('.header__search-wrap'),
		    $searchBox = $searchWrap.find('.header__search-hidden');
		if ($searchBox.hasClass('open')) {
			$searchBox.children('.js-form')[0].reset();
		}

		$(this).toggleClass('active');
		$searchWrap.toggleClass('open');
		$searchBox.toggleClass('open');
	});

	$('.header__search-input').keypress(function (event) {
		if (event.which === 13) {
			event.preventDefault();
			$(this).closest('.js-form').submit();
		}
	});

	$(document).click(function (e) {
		if (!$searchWrap.is(e.target) && $searchWrap.has(e.target).length === 0) {
			$searchBox.removeClass('open');
			$searchWrap.removeClass('open');
			$searchButton.removeClass('active');
			$searchBox.children('.js-form')[0].reset();
		}
	});
}

function headerLang() {
	$dropdownBtn.on('click', function () {
		var $dropdownWrap = $(this).closest('.header__top-dropdown-wrap'),
		    $dropdown = $dropdownWrap.find('.header__top-dropdown');

		$dropdownWrap.toggleClass('open');
		$dropdown.slideToggle('fast');
		$dropdownIcon.toggleClass('open');
	});

	$(document).click(function (e) {
		if (!$dropdownWrap.is(e.target) && $dropdownWrap.has(e.target).length === 0) {
			$dropdown.slideUp('fast');
			$dropdownIcon.removeClass('open');
			$dropdownWrap.removeClass('open');
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.headerSearch = headerSearch;
exports.headerLang = headerLang;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initSelect = undefined;

__webpack_require__(9);

// ----------------------------------------
// Private
// ----------------------------------------

var $select = $('.select2');
var wrap = void 0;
var placeholder = void 0;
var $closeBtn = $('.filter-close-btn');

// ----------------------------------------
// Public
// ----------------------------------------

function initSelect() {
	// if(!$select.length) {
	// 	return false;
	// }

	$select.each(function (index) {
		var $this = $(this);
		wrap = $this.closest('.select2-wrap');
		placeholder = $this.data('placeholder');

		$this.select2({
			minimumResultsForSearch: Infinity,
			dropdownParent: wrap,
			placeholder: placeholder,
			width: 'resolve'
		});

		$this.on('select2:select', function () {
			var $container = $this.next('.select2-container');
			var $wrap = $container.closest('.select2-wrap');
			$container.addClass('selected');
			$wrap.addClass('selected');
		});

		$this.on('select2:unselect', function () {
			var $container = $this.next('.select2-container');
			var $wrap = $container.closest('.select2-wrap');
			$container.removeClass('selected');
			$wrap.removeClass('selected');
		});
	});

	$closeBtn.on('click', function () {
		var $parent = $(this).closest('.select2-wrap');
		var $selected = $parent.find($select);
		$selected.val('').trigger('change');
		$selected.trigger('select2:unselect');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initSelect = initSelect;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Public
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
function subMenuToggle(item, wrap, slide) {
	var $wrap = void 0;
	var $openWrap = $(wrap + '.open');
	var $this = void 0;

	if ($openWrap) {
		$openWrap.find(slide).slideDown('fast');
	}

	$(item).click(function (e) {
		e.preventDefault();

		$this = $(this);
		$wrap = $this.closest($(wrap));

		$wrap.find(slide).slideToggle('fast');
		$wrap.toggleClass('open');
		$this.toggleClass('open');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.subMenuToggle = subMenuToggle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initRangeSlider = undefined;

__webpack_require__(42);

__webpack_require__(43);

// ----------------------------------------
// Private
// ----------------------------------------

var $rangeSlider = $('.price-slider');
var $minCost = $('.min-cost');
var $maxCost = $('.max-cost');
var min = $rangeSlider.data('min');
var max = $rangeSlider.data('max');

// ----------------------------------------
// Public
// ----------------------------------------

function initRangeSlider() {
	if (!$rangeSlider.length) {
		return false;
	}

	$rangeSlider.each(function (i, el) {
		var $el = $(el),
		    $wrap = $el.closest('.for-filter-js'),
		    $minCost = $wrap.find('.min-cost'),
		    $maxCost = $wrap.find('.max-cost');
		var min = $el.data('min'),
		    max = $el.data('max');

		$el.slider({
			min: min,
			max: max,
			range: true,
			values: [min, max],

			stop: function stop(event, ui) {
				$minCost.val($el.slider('values', 0));
				$maxCost.val($el.slider('values', 1));
			},

			slide: function slide(event, ui) {
				$minCost.val($el.slider('values', 0));
				$maxCost.val($el.slider('values', 1));
			}
		});

		$minCost.change(function () {
			var minValue = $minCost.val();
			var maxValue = $maxCost.val();

			if (parseInt(minValue) > parseInt(maxValue)) {
				minValue = maxValue;
				$minCost.val(minValue);
			}

			$rangeSlider.slider('values', 0, minValue);
		});

		$maxCost.change(function () {
			var minValue = $minCost.val();
			var maxValue = $maxCost.val();

			if (maxValue > max) {
				maxValue = max;
				$maxCost.val(max);
			}

			if (parseInt(minValue) > parseInt(maxValue)) {
				maxValue = minValue;
				$maxCost.val(maxValue);
			}

			$el.slider('values', 1, maxValue);
		});

		$minCost.keypress(function (event) {
			var key = void 0;
			var keyChar = void 0;

			if (event.keyCode) key = event.keyCode;else if (event.which) key = event.which;

			if (key === null || key === 0 || key === 8 || key === 13 || key === 9 || key === 46 || key === 37 || key === 39) return true;
			keyChar = String.fromCharCode(key);

			if (!/^[0-9]+$/.test(keyChar)) return false;
		});

		$maxCost.keypress(function (event) {
			var key = void 0;
			var keyChar = void 0;

			if (event.keyCode) key = event.keyCode;else if (event.which) key = event.which;

			if (key === null || key === 0 || key === 8 || key === 13 || key === 9 || key === 46 || key === 37 || key === 39) return true;
			keyChar = String.fromCharCode(key);

			if (!/^[0-9]+$/.test(keyChar)) return false;
		});
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initRangeSlider = initRangeSlider;

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var $showMore = $('.item__show-more');
var $showMoreWrap = $('.item__description');

// ----------------------------------------
// Public
// ----------------------------------------

function textWrap() {
	if (!$showMoreWrap.length) {
		return false;
	}

	if ($showMoreWrap.outerHeight() > 400) {
		$showMoreWrap.addClass('small');
		$showMore.show();
	}

	$showMore.on('click', function () {
		$showMoreWrap.addClass('show').removeClass('small');
		$(this).hide();
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.textWrap = textWrap;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var $map = $('#map');
var icon = '/Media/assets/css/static/pic/map-marker.png';

function setPlace(latitude, longitude) {
	var place = new google.maps.LatLng(latitude, longitude); // eslint-disable-line no-undef

	return place;
}

// ----------------------------------------
// Public
// ----------------------------------------

function initMap() {
	if (!$map.length) {
		return false;
	}

	var location = {
		latitude: $map.data('lat'),
		longitude: $map.data('lng')
	};

	var map = new google.maps.Map(document.getElementById('map'), { // eslint-disable-line no-undef
		zoom: 15,
		center: setPlace(location.latitude, location.longitude),
		scrollwheel: false
	});

	var marker = new google.maps.Marker({ // eslint-disable-line no-undef, no-unused-vars
		position: setPlace(location.latitude, location.longitude),
		map: map,
		optimized: false,
		icon: icon,
		title: ''
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initMap = initMap;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Wezom Standard Tabs
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(47);

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Не реагировать на клик
 * @param {JQuery} $button
 * @return {boolean|undefined}
 * @private
 */
function noReact($button) {
	return $button.hasClass(wsTabs.cssClass.active) || $button.hasClass(wsTabs.cssClass.disabled) || $button.prop('disabled');
}

/**
 * @param {JQuery} $button
 * @param {JQuery} $context
 * @private
 */
function changeTab($button, $context) {
	var myNs = $button.data(wsTabs.keys.ns);
	var myName = $button.data(wsTabs.keys.button);

	var buttonsSelector = '[data-' + wsTabs.keys.ns + '="' + myNs + '"][data-' + wsTabs.keys.button + ']';
	var blocksSelector = '[data-' + wsTabs.keys.ns + '="' + myNs + '"][data-' + wsTabs.keys.block + ']';
	var blockSelector = '[data-' + wsTabs.keys.ns + '="' + myNs + '"][data-' + wsTabs.keys.block + '="' + myName + '"]';

	/**
  * @type {JQuery}
  */
	var $block = $button.getMyElements(wsTabs.keys.myBlock, blockSelector);
	if (noReact($button)) {
		$button.add($block).trigger(wsTabs.events.again);
		return false;
	}

	/**
  * @type {JQuery}
  */
	var $siblingBlocks = $block.getMyElements(wsTabs.keys.myBlocks, blocksSelector, $context, true);

	/**
  * @type {JQuery}
  */
	var $siblingButtons = $button.getMyElements(wsTabs.keys.myButtons, buttonsSelector, $context, true);

	$siblingButtons.add($siblingBlocks).removeClass(wsTabs.cssClass.active).trigger(wsTabs.events.off);
	$button.add($block).addClass(wsTabs.cssClass.active).trigger(wsTabs.events.on);
}

/**
 * Активация табов, если нету активных
 * @param {JQuery} $buttons
 * @param {JQuery} $context
 * @private
 */
function setActiveIfNotHave($buttons, $context) {
	var ns = $buttons.data(wsTabs.keys.ns);
	var selector = '[data-' + wsTabs.keys.ns + '="' + ns + '"]';
	var $group = $buttons.filter(selector);

	if ($group.length) {
		var $active = $group.filter('.' + wsTabs.cssClass.active);
		if (!$active.length) {
			changeTab($group.eq(0), $context);
		}

		if ($group.length < $buttons.length) {
			setActiveIfNotHave($buttons.not(selector), $context);
		}
	}
}

/**
 * Сброс зависимолстей
 * @param {JQuery} $list
 * @param {Array.<string>} keys
 * @private
 */
function _dropDependencies($list, keys) {
	$list.each(function (i, el) {
		var $item = $(el);
		wsTabs.keys.forEach(function (key) {
			$item.data(key, null);
		});
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @namespace
 */
var wsTabs = {
	/**
  * События
  * @enum {string}
  * @sourceCode
  */
	events: {
		on: 'wstabs-on',
		off: 'wstabs-off',
		again: 'wstabs-again'
	},

	/**
  * CSS классы
  * @enum {string}
  * @sourceCode
  */
	cssClass: {
		active: 'is-active',
		disabled: 'is-disabled'
	},

	/**
  * Ключи
  * @enum {string}
  * @sourceCode
  */
	keys: {
		ns: 'wstabs-ns',
		button: 'wstabs-button',
		block: 'wstabs-block',
		myBlock: '$myWsTabsBlock',
		myBlocks: '$myWsTabsBlocks',
		myButtons: '$myWsTabsButtons'
	},

	/**
  * Инициализация
  * @param {JQuery} [$context=$(document)]
  * @sourceCode
  */
	init: function init() {
		var $context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

		$context.on('click', '[data-' + wsTabs.keys.button + ']', { $context: $context }, function (event) {
			event.preventDefault();
			changeTab($(this), $context);
		});
	},


	/**
  * Принудительная активация табов, если нету активных
  * @param {JQuery} [$context=$(document)]
  * @sourceCode
  */
	setActive: function setActive() {
		var $context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

		var $buttons = $context.find('[data-' + wsTabs.keys.button + ']');
		setActiveIfNotHave($buttons, $context);
	},


	/**
  * Сброс всех связей.
  * Актуально при динамическом добавление новый кнопок и блоков в уже существующие группы табов
  * @param {JQuery} [$context=$(document)]
  * @sourceCode
  */
	dropDependencies: function dropDependencies() {
		var $context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

		var $buttons = $context.find('[data-' + wsTabs.keys.button + ']');
		var $blocks = $context.find('[data-' + wsTabs.keys.block + ']');
		_dropDependencies($buttons, [wsTabs.keys.myBlock, wsTabs.keys.myButtons]);
		_dropDependencies($blocks, [wsTabs.keys.myBlocks]);
	}
};

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = wsTabs;

/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Public
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
function selectWord($selector, selectClass, word) {
	$selector = $selector || $('.js-select');
	selectClass = selectClass || 'is-select';
	word = word || $('.js-select-word').data('select');

	if ($selector.length && word) {
		$selector.each(function () {
			var $this = $(this);
			var html = $this.html();
			$this.html(html.replace(new RegExp(word, 'ig'), '<span class="' + selectClass + '">$&</span>'));
		});
	}
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.selectWord = selectWord;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * template name
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------
// ----------------------------------------
// Private
// ----------------------------------------

// ----------------------------------------
// Public
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
function videoController(slider) {}
// let $slider = $(slider),
// 	$videoList = $slider.find('video');
//
// $videoList.each(function (i,el) {
// 	// el.pause();
//
// 	console.log(el)
// 	el.addEventListener('ended', function () {
// 		console.log('video Off');
// 		el.pause();
// 	}, false);
//
// 	$(el).on("startVideo", function() {
// 		el.start();
//
// 	$(el).on("ended", function() {
// 		alert("Video Finished");
// 	});
//
// });

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = videoController;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Вывод "Wezom" баннера в консоли браузера
 * @module
 */

(function (window) {
	var userAgent = window.navigator.userAgent.toLowerCase();
	var staticText = 'Агенство системных интернет-решений';
	var staticUrl = '> http://wezom.com.ua/';
	var staticLine = '----------------------------';

	var isWebkit = function (ua) {
		var webkit = 'WebkitAppearance' in document.body.style;
		var notEdge = !(ua.indexOf(' edge/') > 0);

		return webkit && notEdge;
	}(userAgent);

	var isIeOrEdge = function (ua) {
		var ie = /*@cc_on!@*/false || document.documentMode; // eslint-disable-line
		var edge = ua.indexOf(' edge/') > 0;

		return ie || edge;
	}(userAgent);

	if (isIeOrEdge) {
		window.console.info(staticText);
		window.console.info(staticUrl);
		window.console.log(staticLine);
	} else if (isWebkit) {
		var title = '%c';

		for (var i = 0; i < 12; i++) {
			title += ' ';
		}

		window.console.info(staticUrl);
		window.console.log(title, 'font: 75px/100% sans-serif; background: no-repeat url(data:image/jpeg;base64,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); background-size: 100%');
	} else {
		var _window$console;

		var _title = 'WEZOM';
		var banner = '\n%c' + _title.split('').join('%c %c') + '%c\n';
		var styler = [];

		var symbol = ['font:32px/1.5 Helvetica,Arial,sans-serif', 'color:#fff', 'background-color:#bb1919', 'padding:4px 14px'].join(';');

		_title.split('').forEach(function (arg) {
			styler.push(symbol);
			styler.push('');
		});

		(_window$console = window.console).log.apply(_window$console, [banner].concat(styler));
		window.console.log(staticText);
		window.console.log(staticUrl);
		window.console.log(staticLine);
	}
})(window);

/***/ })
],[14]);


// WEBPACK FOOTER //
// initialize.js